module.exports = __webpack_public_path__ + "./MiaoPhoto_f96320de437d158a913787d37143fc17.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/MiaoPhoto.png
// module id = 499
// module chunks = 0